module.exports = __webpack_public_path__ + "assets/img/content-bg.23dc38a0.png";